<template>
  <div class="TlDesk">
    <TlDeskRange
      v-for="(range, rangeIndex) in model"
      :key="rangeIndex"
      :range="range"
      :active="rangeIndex == activeRange"
      @range-click="$emit('range-click', rangeIndex)"
    >
      <TlDeskPin
        v-show="rangeIndex == activeRange"
        v-for="(pin, pinIndex) in range.pins"
        :key="pinIndex"
        :index="pinIndex"
        :range="range"
        :pin="pin"
        :active="pinIndex == activePin"
        @pin-click="$emit('pin-click', pinIndex)"
      />
    </TlDeskRange>
  </div>
</template>

<script>
import TlDeskRange from "../TlDeskRange";
import TlDeskPin from "../TlDeskPin";

export default {
  props: {
    model: Array,
    activeRange: Number,
    activePin: Number,
  },
  components: {
    TlDeskRange,
    TlDeskPin,
  },
};
</script>

<style lang="stylus" scoped>
@import './TlDesk.styl';
</style>
